import Condition from "../core/condition";
import { evaluate } from "mathjs";
export class DialogRenderer {
    constructor() {
        var _a;
        this.time = 0;
        this.canvas = document.getElementById("canvas");
        this.context = (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.getContext("2d");
    }
    getActualScroll(scene, time) {
        var _a;
        const direction = scene.scrollBackwards ? -1 : 1;
        const scroll = Math.max(0, ((_a = scene.scroll) !== null && _a !== void 0 ? _a : 0) + (scene.scrollStart ? direction * Math.floor((time - scene.scrollStart) / 20) : 0));
        return scroll;
    }
    isMessageCompleted(scene) {
        var _a, _b, _c, _d, _e, _f;
        if (!((_a = scene.dialog) === null || _a === void 0 ? void 0 : _a.labels) || !((_b = scene.dialog) === null || _b === void 0 ? void 0 : _b.fontSheet)) {
            return true;
        }
        const lastLabel = (_c = scene.dialog) === null || _c === void 0 ? void 0 : _c.labels[scene.dialog.labels.length - 1];
        if (!lastLabel.text && !scene.message && !((_d = scene.messages) === null || _d === void 0 ? void 0 : _d.length)) {
            return true;
        }
        if (lastLabel.nonBlocking) {
            return true;
        }
        let shift = 0;
        this.getRealText(scene, (_e = lastLabel.text) !== null && _e !== void 0 ? _e : scene.message).split("").forEach(letter => {
            var _a;
            if ((_a = scene.dialog) === null || _a === void 0 ? void 0 : _a.fontSheet) {
                const [lx, ly, lw, lh] = scene.dialog.fontSheet.getCropForLetter(letter);
                shift += lw + 1;
            }
        });
        return !scene.scrollStart && ((_f = scene.scroll) !== null && _f !== void 0 ? _f : 0) > shift;
    }
    isCompleted(scene) {
        var _a;
        return this.isMessageCompleted(scene) && !((_a = scene.messages) === null || _a === void 0 ? void 0 : _a.length);
    }
    addListener(scene) {
        if (!this.onKey) {
            this.onKey = {
                down: (e) => {
                    if (e.code === "Space" || e.code === "ArrowRight" || e.code === "ArrowLeft" || e.code === "ArrowDown" || e.code === "ArrowUp") {
                        if (!scene.scrollStart) {
                            scene.scrollStart = this.time;
                        }
                        scene.scrollBackwards = e.code === "ArrowLeft" || e.code === "ArrowUp" ? true : undefined;
                    }
                },
                up: (e) => {
                    scene.scroll = this.getActualScroll(scene, this.time);
                    delete scene.scrollBackwards;
                    scene.scrollStart = undefined;
                }
            };
            document.addEventListener("keydown", this.onKey.down);
            document.addEventListener("keyup", this.onKey.up);
        }
    }
    removeListener() {
        if (this.onKey) {
            document.removeEventListener("keydown", this.onKey.down);
            document.removeEventListener("keyup", this.onKey.up);
            delete this.onKey;
        }
    }
    render(menu, timestamp) {
        this.time = timestamp;
        const { dialog, dialogs } = menu;
        [...dialogs !== null && dialogs !== void 0 ? dialogs : [], dialog].forEach(dialog => {
            if (dialog) {
                const { labels, fontSheet } = dialog;
                if (fontSheet) {
                    labels === null || labels === void 0 ? void 0 : labels.forEach(label => {
                        if (dialog.hidden && !label.fixed) {
                            return;
                        }
                        if (dialog.lastDialog && !menu.message) {
                            return;
                        }
                        if (this.context) {
                            this.context.save();
                        }
                        this.renderOutline(label, fontSheet, menu, timestamp, menu.message);
                        if (this.context) {
                            this.context.restore();
                        }
                    });
                    labels === null || labels === void 0 ? void 0 : labels.forEach(label => {
                        if (dialog.hidden && !label.fixed) {
                            return;
                        }
                        if (this.context) {
                            this.context.save();
                        }
                        this.renderLabel(label, fontSheet, menu, timestamp, menu.message);
                        if (this.context) {
                            this.context.restore();
                        }
                    });
                }
                if (menu.message && this.isMessageCompleted(menu)) {
                    menu.message = undefined;
                    menu.scroll = 0;
                }
            }
        });
    }
    stopRendering() {
        this.removeListener();
    }
    renderOutline(label, fontSheet, menu, timestamp, message) {
        var _a, _b, _c;
        const { x, y, hidden } = label;
        const text = (_a = label.text) !== null && _a !== void 0 ? _a : message;
        let shift = 0;
        if (this.context) {
            if ((label.box || Condition.eval(label.outline, { scene: menu })) && text) {
                let minX = Number.MAX_SAFE_INTEGER, minY = Number.MAX_SAFE_INTEGER, maxX = 0, maxY = 0;
                const realText = this.getRealText(menu, text);
                if (realText.length) {
                    realText.split("").forEach(letter => {
                        const [, , lw, lh] = fontSheet.getCropForLetter(letter);
                        minX = Math.min(minX, x + shift);
                        maxX = Math.max(maxX, x + shift + lw);
                        minY = Math.min(minY, y);
                        maxY = Math.max(maxY, y + lh);
                        shift += lw + 1;
                    });
                }
                this.context.fillStyle = "#00000077";
                const rectX = minX - 1;
                const rectY = minY;
                const rectWidth = Math.min(maxX - minX, (_b = label.width) !== null && _b !== void 0 ? _b : maxX - minX) + 2;
                const rectHeight = Math.min(maxY - minY, (_c = label.height) !== null && _c !== void 0 ? _c : maxY - minY) + (label.box ? 5 : 2);
                this.context.fillRect(rectX, rectY, rectWidth, rectHeight);
                if (label.box) {
                    const completed = this.isCompleted(menu);
                    if (!completed) {
                        this.addListener(menu);
                    }
                    else {
                        this.removeListener();
                    }
                    if (timestamp % 450 < 300 && !menu.scrollStart && !completed) {
                        this.context.fillStyle = "white";
                        this.context.lineWidth = 1;
                        this.context.beginPath();
                        this.context.moveTo(rectX + rectWidth - 1, rectY + rectHeight - 4);
                        this.context.lineTo(rectX + rectWidth - 3.5, rectY + rectHeight - 1.5);
                        this.context.lineTo(rectX + rectWidth - 6, rectY + rectHeight - 4);
                        this.context.closePath();
                        this.context.fill();
                    }
                }
            }
        }
    }
    getRealText(scene, text) {
        var _a, _b;
        const inventoryExtract = text.match(/{item.(\d+)}/);
        if (inventoryExtract) {
            return (_b = (_a = scene.inventory) === null || _a === void 0 ? void 0 : _a[parseInt(inventoryExtract[1])]) !== null && _b !== void 0 ? _b : "";
        }
        const extract = text.match(/{([^}]*)}/);
        const realText = (extract === null || extract === void 0 ? void 0 : extract[1]) ? text.replace(`{${extract === null || extract === void 0 ? void 0 : extract[1]}}`, evaluate(extract === null || extract === void 0 ? void 0 : extract[1], Object.assign({}, scene))) : text;
        return extract ? this.getRealText(scene, realText) : realText;
    }
    renderLabel(label, fontSheet, menu, timestamp, message) {
        var _a;
        const { x, y, hidden } = label;
        const text = (_a = label.text) !== null && _a !== void 0 ? _a : message;
        const blinkRate = Condition.eval(label.blinkRate, { scene: menu });
        if (blinkRate) {
            if (!menu.startTime) {
                menu.startTime = timestamp;
            }
            const ellapsed = timestamp - menu.startTime;
            const progress = ellapsed % ((blinkRate[0] + blinkRate[1]) * 1000);
            if (progress > blinkRate[0] * 1000) {
                return;
            }
        }
        if (Condition.eval(hidden, { scene: menu })) {
            return;
        }
        let shift = 0;
        if (this.context) {
            if (label.width && label.height) {
                this.context.beginPath();
                this.context.moveTo(x, y);
                this.context.lineTo(x + label.width, y);
                this.context.lineTo(x + label.width, y + label.height);
                this.context.lineTo(x, y + label.height);
                this.context.closePath();
                this.context.clip();
            }
            if (text) {
                shift = 0;
                const canScroll = !label.noScroll ? 1 : 0;
                const realText = this.getRealText(menu, text);
                if (realText.length) {
                    realText.split("").forEach(letter => {
                        var _a, _b;
                        if (this.context && ((_a = fontSheet.asset) === null || _a === void 0 ? void 0 : _a.image)) {
                            const [lx, ly, lw, lh] = fontSheet.getCropForLetter(letter);
                            this.context.drawImage((_b = fontSheet.asset) === null || _b === void 0 ? void 0 : _b.image, lx, ly, lw, lh, x + shift - canScroll * this.getActualScroll(menu, timestamp), y, lw, lh);
                            shift += lw + 1;
                        }
                    });
                }
            }
        }
    }
}
